import { ENTITY_RECORD_PATH } from './entity.record.contracts';

export interface EntityRecordCopy {
  kind: 'link' | 'number';
  text: string;
}

/**
 * What a record's copy action puts on the clipboard: the record's absolute URL, or with Shift its
 * document number. Only generic `/entity/...` pages are offered — a legacy canonical URL is not a v2
 * link to share — and Shift falls back to the link while the record has no number yet (a draft).
 */
export function resolveEntityRecordCopy(canonicalUrl: string | null | undefined, origin: string, documentNumber: string | null, shift: boolean): EntityRecordCopy | null {

  if (!canonicalUrl?.startsWith(`/${ENTITY_RECORD_PATH}/`)) return null;
  if (shift && documentNumber) return { kind: 'number', text: documentNumber };
  return { kind: 'link', text: `${origin}${canonicalUrl}` };
}
